<template>
  <Navpanel />
  <ImageGenerator />
</template>

<script>
import ImageGenerator from './components/ImageGenerator.vue'
import Navpanel from './components/NavPanel.vue'
export default {
  name: 'App',
  components: {
    Navpanel,
    ImageGenerator
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
